import {useCallback, useEffect, useState} from "react";
import axiosInstance from "../../../../../axiosInstance";
import {useNavigate} from "react-router-dom";

const useGetProjectDetail = ({projectId}) => {
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  const getData = useCallback(async (projectId) => {
    setLoading(true);
    const fullUrl = window.localStorage.getItem("BaseURL") + "/services/projectmanagement/api/projects/" + projectId;
    return new Promise((resolve) => {
      axiosInstance
        .get(fullUrl)
        .then(res => {
          setData(res.data)
          resolve(res.data)
        })
        .catch(err => {
          console.error(err)
          if (err?.status >= 400 || err?.status <= 499) {
            navigate('/Home')
          }
        })
        .finally(() => setLoading(false));
    })
  }, [navigate])

  useEffect(() => {
    if (projectId) {
      getData(projectId)
    }
  }, [getData, projectId])

  return {data, loading, getData}
};

export default useGetProjectDetail;
